export var getSvgWithColor = function (rawSvg, rgbaString) {
    if (rgbaString === void 0) { rgbaString = 'rgba(0,0,0,0.1)'; }
    var newRawSvg = rawSvg
        .replace(/fill=["']#[fF][fF][fF]["']/g, "___FILL_CMD___=\"#fff\"")
        .replace(/fill=["']#[fF][fF][fF][fF][fF][fF]["']/g, "___FILL_CMD___=\"#ffffff\"")
        .replace(/stroke=["']#[fF][fF][fF][fF][fF][fF]["']/g, "___STROKE_CMD___=\"#ffffff\"")
        .replace(/fill=["']none["']/g, "___FILL_CMD___=\"none\"")
        .replace(/fill=["'][^"^']+["']/g, "fill=\"" + rgbaString + "\"")
        .replace(/stroke=["'][^"^']+["']/g, "stroke=\"" + rgbaString + "\"")
        .replace(/___FILL_CMD___="/g, 'fill="')
        .replace(/___STROKE_CMD___="/g, 'stroke="');
    var base64 = window.btoa(newRawSvg);
    return "url(data:image/svg+xml;base64," + base64 + ")";
};
//# sourceMappingURL=svg-utils.js.map